import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Route-change scroll handler.
 * - On every pathname change without a hash, scrolls to top instantly.
 * - If the URL has a hash (e.g. /#nasil-calisir), leaves scrolling to the
 *   landing page's existing anchor handler so smooth-scroll-to-section still works.
 * - Search-string only changes (?foo=bar) do NOT trigger a scroll-to-top.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
